export const gateway = "https://qat-western-bms-api.link-nonprod.wawanesalife.com";
export const LoginUrlParameter = "https://qat-brokers.auth.ca-central-1.amazoncognito.com/login?client_id=m6g7vh766g3b5i57b49hsckvs&response_type=token&scope=email+openid&redirect_uri=https%3A%2F%2Fqat-western-bms.link-nonprod.wawanesalife.com%2Fredirect";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/wawanesalife";
export const HasLinkAdmin = "no";
export const BrokerPoolClientParameter = "m6g7vh766g3b5i57b49hsckvs";
export const BrokerPoolDomainParameter = "qat-brokers";
export const BrokerPoolParameter = "ca-central-1_f0PTGfA8O";

export const TopMenuLink1Caption = "Wawanesa Life";
export const TopMenuLink1Url = "https://www.wawanesalife.com";
export const TopMenuLink2Caption = "QuickTerm quoter";
export const TopMenuLink2Url = "https://western.link.wawanesalife.com";

//updated on Mon Sep 15 2025 15:44:28 GMT+0000 (Coordinated Universal Time)
